import React from "react"
import { FormControl, OverlayTrigger } from "react-bootstrap"
import FieldTypes from "src/pages/dynamic_forms/Types/FieldTypes"
import DynamicFormPaletteTypes from "src/store/DyanmicFormPalette/types"
import TrashCan from "src/pages/dynamic_forms/Utils/TrashCan/TrashCan"
import paletteEngine from "src/pages/dynamic_forms/Utils/paletteEngine"
import mobileFriendlyWarning from "src/pages/dynamic_forms/Utils/MobileFriendlyWarning/MobileFriendlyWarning"
import reoccuringText from "src/pages/dynamic_forms/Utils/ReoccuringText"
import "./NumberField.css"
import "../../DynamicForm.css"

interface Props {
    manageParentState: Function
    handleChange: Function
    field: FieldTypes
    row: number
    col: number
    formManagerField?: boolean
    configField?: boolean
    templateField?: boolean
    remove: Function
    palette: Array<DynamicFormPaletteTypes>
    readOnly?: boolean
}

function NumberField(props: Props) {

    // console.log("df_FieldNumberField props", props)

    const field = props.field
    const value = !props.formManagerField ? field.Value : null
    const name = field.Name || "Number"
    const formatter = field.Formatter ? field.Formatter.formatter : null
    const templateField = props.templateField
    const formManagerField = props.formManagerField
    const configField = props.configField
    const fieldType = templateField ? "TemplateField" : formManagerField ? "FormMangerField" : configField ? "ConfigField" : "Field"

    return (
        <div className={`DynamicForm${fieldType} DynamicFormNumber${fieldType}`} style={{ backgroundColor: `${paletteEngine.getPaletteColor("fieldBackgroundColor")}` }}>
            <div className="DynamicFormFieldHeader">
                {!formManagerField && <div className="DynamicFormFieldHeaderLeft">
                    <p style={{ color: `${paletteEngine.getPaletteColor("headerTextColor")}` }}>{name}</p>
                    {field.Required && !field.Value && <span className="material-icons" style={{ color: `${paletteEngine.getPaletteColor("requiredFieldAsteriskColor")}` }}>*</span>}
                </div>}
                <div className="DynamicFormFieldHeaderRight">
                    {templateField && <div className="DynamicFormFieldHeaderRightSettings">
                        <div className="DynamicFormFieldHeaderRightSettingsMultiColumnarWarning">
                            {props.col > 0 &&
                                <OverlayTrigger placement="right" overlay={mobileFriendlyWarning("Rows with multiple columns", reoccuringText.multipleColumnInRowWarningText)}>
                                    <span
                                        className="material-icons"
                                        style={{ color: `${paletteEngine.getPaletteColor("editorConfigMultiColumnsWarningIconColor")}` }}>
                                        priority_high
                                    </span>
                                </OverlayTrigger>}
                        </div>
                        <span className="material-icons DynamicFormFieldHeaderRightSettingsGear"
                            style={{ color: `${paletteEngine.getPaletteColor("editorConfigGearColor")}` }}
                            onClick={() => props.manageParentState([{ key: "configTarget", value: { row: props.row, col: props.col } }])}>
                            settings
                        </span>
                        <TrashCan clickCallback={() => props.remove(field.Type, props.row, props.col, true)} color={`${paletteEngine.getPaletteColor("editorTrashBinColor")}`} />
                    </div>}
                </div>
            </div>
            <div className="DynamicFormFieldBody">
                <FormControl onFocus={() => props.manageParentState([{ key: "target", value: { row: props.row, col: props.col, key: "Value" } }])}
                    //@ts-ignore
                    onChange={(e) => {
                        const val = e.target.value
                        const formatted = formatter ? formatter(val) : null
                        const input = formatted ? formatted : val
                        props.handleChange({ target: { value: input } })
                    }}
                    value={value || ""}
                    type="number"
                    disabled={formManagerField}
                    style={{ backgroundColor: `${paletteEngine.getPaletteColor("fieldInputBackgroundColor")}`, color: `${paletteEngine.getPaletteColor("fieldInputTextColor")}` }}
                />
            </div>
        </div>
    )
}

export default NumberField